import { createZodDto } from 'nestjs-zod/dto';
import z from 'zod';
import { createListQuery } from '#web-service-api/common';
import { GuestLinkResponseSchema } from '../response';
export const DEFAULT_GUEST_LINKS_PAGE_LIMIT = 100;
export const GuestLinksListQuery = createListQuery({
    schema: GuestLinkResponseSchema,
    sortable: {
        by: ['name', 'expiresAt', 'createdAt'],
        default: '-createdAt',
    },
    pageSize: {
        default: DEFAULT_GUEST_LINKS_PAGE_LIMIT,
        max: DEFAULT_GUEST_LINKS_PAGE_LIMIT,
    },
    filters: z.object({}),
});
export class GuestLinksListQueryDto extends createZodDto(GuestLinksListQuery.codec) {
}
